import React, { PropTypes } from 'react';
import DatePicker from 'react-datepicker';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';
import { momentSetHKTimezone } from '../../../utils/dateUtils';

const QuotationDate = (props) => {
  return (
    <FormGroup controlId="quotationDate">
      <Col componentClass={ControlLabel} sm={5}>
        Quotation Date *
      </Col>
      <Col sm={7}>
         <DatePicker
            placeholderText="DD/MM/YYYY"
            dateFormat="DD/MM/YYYY"
            todayButton={'Today'}
            selected={props.quotationDate != null ? momentSetHKTimezone(props.quotationDate) : null}
            onChange={props.handleChangeQuotationDate}
            required
            disabled
            />
      </Col>
    </FormGroup>
  )
}

QuotationDate.propTypes = {
  quotationDate: PropTypes.string,
  handleChangeQuotationDate: PropTypes.func
};

export default QuotationDate;



// WEBPACK FOOTER //
// ./src/app/components/quotationDate/QuotationDate.js